import {FieldDate, FieldInput} from "@kroschke/react-ui";
import {FieldDualInput, FormSection} from "../../../ui";
import {
    VdaDocumentDefaultBaseProps,
    VdaDocumentDefaultFormData,
    VdaDocumentDefaultValidation
} from "./VdaDocumentDefaultForm";
import {ReactNode} from "react";


export interface VdaDocumentCor2FormData extends VdaDocumentDefaultFormData{
    corNumber: string
    licensePlate: string
    registrationDateFirst?: string
    registrationDateLatest?: string
    vinCheckDigit?: string
}

export interface VdaDocumentCor2Validation extends VdaDocumentDefaultValidation {
    corNumber?: string
    licensePlate?: string
    registrationDateFirst?: string
    registrationDateLatest?: string
    vinCheckDigit?: string
}

export interface VdaDocumentCor2FormProps extends VdaDocumentDefaultBaseProps {
    disableLicensePlate: boolean
    validation: VdaDocumentCor2Validation
    value: VdaDocumentCor2FormData
    onChange: (value: VdaDocumentCor2FormData) => any
    onBlur: () => any
    header: ReactNode
}

export function VdaDocumentCor2Form({
                                        value,
                                        disabled,
                                        disableLicensePlate,
                                        onChange,
                                        onBlur,
                                        validation,
                                        label,
                                        header
                                    }: VdaDocumentCor2FormProps) {
    return <FormSection
        label={label}
        header={header}
        children={
            <>
                <div className={"columns"}>
                    <div className={"column is-one-third"}>
                        <FieldDualInput
                            label={"Fahrgestellnummer | Prüfziffer"}
                            invalid={Boolean(validation.vinCheckDigit)}
                            disabledLeft={true}
                            disabledRight={disabled}
                            help={validation.vinCheckDigit}
                            value={{
                                left: value.vin,
                                right: value.vinCheckDigit
                            }}
                            onChange={v => {
                                onChange({
                                    ...value,
                                    vinCheckDigit: v.right
                                })
                            }}
                            onBlur={() => !disabled && onBlur()}
                        />
                    </div>
                    <div className={"column is-one-third"}>
                        <FieldInput
                            disabled={disabled}
                            label={"Briefnummer"}
                            required={true}
                            maxLength={8}
                            help={validation.corNumber}
                            invalid={Boolean(validation.corNumber)}
                            value={value.corNumber}
                            onBlur={() => !disabled && onBlur()}
                            inputTransform={e => e.toUpperCase()}
                            onChange={corNumber => {
                                onChange({
                                    ...value,
                                    corNumber: corNumber
                                })
                            }}
                        />
                    </div>
                    <div className={"column is-one-third"}>
                        <FieldInput
                            disabled={disabled || disableLicensePlate}
                            label={"Kennzeichen"}
                            help={validation.licensePlate}
                            invalid={Boolean(validation.licensePlate)}
                            value={value.licensePlate}
                            onBlur={() => !disabled && onBlur()}
                            inputTransform={e => e.toUpperCase()}
                            onChange={licensePlate => {
                                onChange({
                                    ...value,
                                    licensePlate: licensePlate
                                })
                            }}
                        />
                    </div>
                </div>
                <div className={"columns"}>
                    <div className={"column is-one-third"}>
                        <FieldDate
                            disabled={disabled}
                            label={"Erstzulassungsdatum"}
                            help={validation.registrationDateFirst}
                            invalid={Boolean(validation.registrationDateFirst)}
                            value={value.registrationDateFirst}
                            onBlur={() => !disabled && onBlur()}
                            onChange={registrationDateFirst => {
                                onChange({
                                    ...value,
                                    registrationDateFirst: registrationDateFirst
                                })
                            }}
                        />
                    </div>
                    <div className={"column is-one-third"}>
                        <FieldDate
                            disabled={disabled}
                            label={"Zulassungsdatum (aktuelles)"}
                            help={validation.registrationDateLatest}
                            invalid={Boolean(validation.registrationDateLatest)}
                            value={value.registrationDateLatest}
                            onBlur={() => !disabled && onBlur()}
                            onChange={registrationDateLatest => {
                                onChange({
                                    ...value,
                                    registrationDateLatest: registrationDateLatest
                                })
                            }}
                        />
                    </div>
                    <div className={"column is-one-third"}>
                        <FieldInput
                            disabled={disabled}
                            label={"Dokumenten-Id"}
                            required={true}
                            help={validation.documentId}
                            invalid={Boolean(validation.documentId)}
                            value={value.documentId}
                            onBlur={() => !disabled && onBlur()}
                            onChange={documentID => {
                                onChange({
                                    ...value,
                                    documentId: documentID
                                })
                            }}
                        />
                    </div>
                </div>
                <div className={"columns"}>
                    <div className={"column is-one-third"}>
                        <FieldInput
                            disabled={disabled}
                            label={"Position"}
                            required={true}
                            help={validation.position}
                            invalid={Boolean(validation.position)}
                            value={`${value.position}`}
                            onBlur={() => !disabled && onBlur()}
                            onChange={position => {
                                onChange({
                                    ...value,
                                    position: parseInt(position) || 0
                                })
                            }}
                        />
                    </div>
                </div>
            </>
        }
    />
}
